var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1384,
    height: 683,
    viewBox: "0 0 1384 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163 0V520.677L1 682.677",
    stroke: "url(#paint0_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209 0V520.677L47 682.677",
    stroke: "url(#paint1_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255 0V520.677L93 682.677",
    stroke: "url(#paint2_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301 0V520.677L139 682.677",
    stroke: "url(#paint3_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347 0V520.677L185 682.677",
    stroke: "url(#paint4_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393 0V520.677L231 682.677",
    stroke: "url(#paint5_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M439 0V520.677L277 682.677",
    stroke: "url(#paint6_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M485 0V520.677L323 682.677",
    stroke: "url(#paint7_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M531 0V520.677L369 682.677",
    stroke: "url(#paint8_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M577 0V520.677L415 682.677",
    stroke: "url(#paint9_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M623 0V520.677L461 682.677",
    stroke: "url(#paint10_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M669 0V520.677L507 682.677",
    stroke: "url(#paint11_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1221 0V520.677L1383 682.677",
    stroke: "url(#paint12_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1175 0V520.677L1337 682.677",
    stroke: "url(#paint13_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1129 0V520.677L1291 682.677",
    stroke: "url(#paint14_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1083 0V520.677L1245 682.677",
    stroke: "url(#paint15_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1037 0V520.677L1199 682.677",
    stroke: "url(#paint16_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M991 0V520.677L1153 682.677",
    stroke: "url(#paint17_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M945 0V520.677L1107 682.677",
    stroke: "url(#paint18_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M899 0V520.677L1061 682.677",
    stroke: "url(#paint19_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M853 0V520.677L1015 682.677",
    stroke: "url(#paint20_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M807 0V520.677L969 682.677",
    stroke: "url(#paint21_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M761 0V520.677L923 682.677",
    stroke: "url(#paint22_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M715 0V520.677L877 682.677",
    stroke: "url(#paint23_linear_605_327)",
    strokeOpacity: 0.4,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_605_327",
    x1: 102,
    y1: 0,
    x2: 102,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_605_327",
    x1: 148,
    y1: 0,
    x2: 148,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_605_327",
    x1: 194,
    y1: 0,
    x2: 194,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_605_327",
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_605_327",
    x1: 286,
    y1: 0,
    x2: 286,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_605_327",
    x1: 332,
    y1: 0,
    x2: 332,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_605_327",
    x1: 378,
    y1: 0,
    x2: 378,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_605_327",
    x1: 424,
    y1: 0,
    x2: 424,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_605_327",
    x1: 470,
    y1: 0,
    x2: 470,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_605_327",
    x1: 516,
    y1: 0,
    x2: 516,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_605_327",
    x1: 562,
    y1: 0,
    x2: 562,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_605_327",
    x1: 608,
    y1: 0,
    x2: 608,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_605_327",
    x1: 1282,
    y1: 0,
    x2: 1282,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_605_327",
    x1: 1236,
    y1: 0,
    x2: 1236,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_605_327",
    x1: 1190,
    y1: 0,
    x2: 1190,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_605_327",
    x1: 1144,
    y1: 0,
    x2: 1144,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_605_327",
    x1: 1098,
    y1: 0,
    x2: 1098,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_605_327",
    x1: 1052,
    y1: 0,
    x2: 1052,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_605_327",
    x1: 1006,
    y1: 0,
    x2: 1006,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_605_327",
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_605_327",
    x1: 914,
    y1: 0,
    x2: 914,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_605_327",
    x1: 868,
    y1: 0,
    x2: 868,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_605_327",
    x1: 822,
    y1: 0,
    x2: 822,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_605_327",
    x1: 776,
    y1: 0,
    x2: 776,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#8DE5E9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBanner);
export default __webpack_public_path__ + "static/media/home-banner.c4390e3b586089ee1c7b4885b03009e8.svg";
export { ForwardRef as ReactComponent };